import React from "react";
import { PopupModal } from "react-calendly";
import { TbHandClick } from "react-icons/tb";
import { Link } from "react-router-dom";
import "./Calendy.scss";



class Calendy extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    render() {
        return (
            <React.Fragment>
                <button onClick={() => this.setState({ isOpen: true })} className='contact-us-btn' style={{ width: '100%' }}>
                    Let's book a meeting
                </button>

                <PopupModal
                    url="https://calendly.com/softmax-tecnology/asesoria-softmax?hide_gdpr_banner=1"
                    pageSettings={this.props.pageSettings}
                    utm={this.props.utm}
                    prefill={this.props.prefill}
                    onModalClose={() => this.setState({ isOpen: false })}
                    open={this.state.isOpen}
                    rootElement={document.getElementById("root")}
                />
            </React.Fragment>
        );
    }
}

export default Calendy;